/*
    Create by BaiZhiming 2015-1-18
*/
"use strict";
angular.module("addWhiteListUserModule", [])
    .controller("addWhiteListUserCtrl", ["$scope", "$timeout", "$modalInstance", "trsHttpService", "modalDialog", "globleParamsSet", "params", "selectedUser", function($scope, $timeout, $modalInstance, trsHttpService, modalDialog, globleParamsSet, params, selectedUser) {
        init();
        var noRightFilter;
        $scope.showSelected = function(node) {
            getGroupData(node);
        };
        $scope.showToggle = function(node) {
            childrenTree(node, function() {});
        };
        $scope.toRight = function() {
            angular.forEach($scope.userDatas, function(data, index, array) {
                data.DESC = data.USERNAME;
                // data.GROUPDESC = $scope.selectedNodePA.GDESC;
                data.GROUPID = $scope.selectedNodePA.GROUPID;
                if (data.selected === "selected") {
                    delete data.selected;
                    $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(data)], angular.copy($scope.itemsSd), "ID", "GROUPID");
                    $scope.userDatas[index].selected = "";
                    $scope.selectedUser.push({"ID": data.ID,"GROUPID": data.GROUPID});
                }
            });
        };
        $scope.chooseUserName = function(type, user) {
            if (angular.isDefined(user.selected) && user.selected === "selected") {
                user.selected = "";
            } else {
                user.selected = "selected";
                if (type == "toChoose") {
                    $scope.toChooseUser = user;
                } else if (type == "cancelChoose") {
                    $scope.cancelChooseUser = user;
                }
            }
        };
        //输入过滤器
        $scope.myFilter = function(expected, actual) {
            var flag = true;
            if ($scope.searchWordLeft !== "" && angular.isDefined($scope.searchWordLeft)) {
                flag = expected.USERNAME.indexOf($scope.searchWordLeft) >= 0 ? true : false;
            }
            return flag;
        };
        //输入过滤器
        //双击选择开始
        $scope.directlyToRight = function(user) {
            delete user.selected;
            user.DESC = user.USERNAME;
            // user.GROUPDESC = $scope.selectedNodePA.GDESC;
            user.GROUPID = $scope.selectedNodePA.GROUPID;
            $scope.selectedUser.push({"ID": user.ID,"GROUPID": user.GROUPID});
            $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(user)], $scope.itemsSd, "ID", "GROUPID");
        };
        //双击选择结束
        //双击取消选择开始
        $scope.directlyToLeft = function(user) {
            globleParamsSet.contrastAfExclArray([user], $scope.itemsSd, "ID", "GROUPID", function(data) {
                $scope.itemsSd = data;
            });
        };
        $scope.selectedAll = function() {
            angular.forEach($scope.userDatas, function(data, index, array) {
                delete data.selected;
                data.DESC = data.USERNAME;
                // data.GROUPDESC = $scope.selectedNodePA.GDESC;
                data.GROUPID = $scope.selectedNodePA.GROUPID;
                $scope.itemsSd = globleParamsSet.arrayContrast([angular.copy(data)], angular.copy($scope.itemsSd), "ID", "GROUPID");
                $scope.userDatas[index].selected = "";
                if ($scope.selectedUser.indexOf(data.ID) < 0) {
                    $scope.selectedUser.push({"ID": data.ID, "GROUPID": data.GROUPID});
                }
            });
        };
        //双击取消选择结束
        $scope.toLeft = function() {
            var toRemoveList = [];
            angular.forEach($scope.itemsSd, function(data, index, array) {
                if (angular.isDefined(data.selected) && data.selected === "selected") {
                    toRemoveList.push(data);
                    $scope.selectedUser.splice($scope.selectedUser.indexOf(data.ID), 1);
                }
            });
            globleParamsSet.contrastAfExclArray(toRemoveList, $scope.itemsSd, "ID", "GROUPID", function(data) {
                $scope.itemsSd = data;
            });
        };
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        $scope.submit = function() {
            $modalInstance.close($scope.itemsSd);
        };

        function init() {
            //组织树配置文件
            $scope.treePAOptions = {
                nodeChildren: "CHILDREN",
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: "a1",
                    li: "a2",
                    liSelected: "a7",
                    iExpanded: "a3",
                    iCollapsed: "a4",
                    iLeaf: "a5",
                    label: "a6",
                    labelSelected: "a8"
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == "false";
                },
                isSelectable: function(node) {
                    return noRightFilter ? true : node.HASRIGHT === "true";
                }
            };
            $scope.expandedPA = angular.copy($scope.expandedTest);
            noRightFilter = angular.isDefined(params) && (angular.isDefined(params) && params.rightFilter === false);
            var treeParams = {
                "serviceid": "mlf_group",
                "methodname": noRightFilter ? "queryGroupTreeWithMyPath" : "queryGroupTreeWithSecondRight" /*"queryGroupTreeWithMyPath"*/
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), treeParams, "get").then(function(data) {
                $scope.treedataPA = [data];
                ExpandedNodes();
            }, function(data) {});
            //初始化最近记录限制
            $scope.limitRecordNum = 10;
            //初始化选择列表
            $scope.itemsSd = selectedUser || [];
            /*var selectedParams = {
                "serviceid": "mlf_extrole",
                "methodname": "getPrivilegeRange",
                "RoleId": roleid
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), selectedParams, "post").then(function(data) {
                $scope.itemsSd = data;
            });*/
            //已进入选择栏的用户id
            $scope.selectedUser = [];

        }
        //默认展开树开始
        function ExpandedNodes() {
            $scope.expandedPA = [];
            $scope.expandedPA.push($scope.treedataPA[0]);
            if (!noRightFilter) return;
            var flag = true;
            angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
                if (data.ISPATH === "true") {
                    flag = false;
                    if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                        $scope.expandedPA.push(data);
                        selfPath(data);
                    } else {
                        $scope.selectedNode = data;
                        getGroupData($scope.selectedNode);
                    }

                }
            });
            if (flag) {
                $scope.selectedNodePA = $scope.treedataPA[0];
                getGroupData($scope.selectedNodePA);
            }
            /*if ($scope.treedataPA[0].CHILDREN === 0) {
                $scope.selectedNodePA = $scope.treedataPA[0];
                getGroupData($scope.selectedNodePA);
            } else {
                angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
                    if (data.ISPATH === "true") {
                        $scope.expandedPA.push(data);
                        if (data.CHILDREN.length !== 0) {
                            selfPath(data);
                        } else {
                            $scope.selectedNodePA = data;
                            getGroupData($scope.selectedNodePA);
                        }

                    }
                });
            }*/
        }
        //默认展开树结束
        function getGroupData(node) {
            $timeout(function() {
                    //此判断如果两次点击同一个树，不重复加载角色列表。
                    $scope.groupObj = node;
                    $scope.oldSelectNode = node;
                    $scope.Datas = [];
                    $scope.userData = null;
                    var params = {
                        "serviceid": "mlf_group",
                        "methodname": "getUsersByGroup",
                        "GroupId": $scope.groupObj.GROUPID
                    };
                    //trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        $scope.userDatas = data;
                        /*if (angular.isDefined(node.CHILDREN)&&node.CHILDREN.length === 0) {
                            childrenTree(node, function() {
                                $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                            });
                        } else {
                            $scope.userDatas = $scope.userDatas.concat(node.CHILDREN);
                        }*/
                    }, function(data) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
                },
                100);
        }

        function selfPath(data) {
            for (var i = 0; i < data.CHILDREN.length; i++) {
            if (data.CHILDREN[i].ISPATH === "true") {
                if (data.CHILDREN[i].HASCHILDREN === "false" || data.CHILDREN[i].CHILDREN.length === 0) {
                    $scope.selectedNodePA = data.CHILDREN[i];
                    getGroupData($scope.selectedNodePA);
                    break;
                } else {
                    $scope.expandedPA.push(data.CHILDREN[i]);
                    selfPath(data.CHILDREN[i]);
                    break;
                }
            }
        }
        }

        function childrenTree(node, callback) {
            if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                var paramsT = {
                    "serviceid": "mlf_group",
                    "methodname": noRightFilter ? "queryChildGroupsWithOutRight" : "queryChildGroupsWithSecondRight",
                    "GroupId": node.GROUPID
                };
                trsHttpService.httpServer("/wcm/mlfcenter.do", paramsT, "get").then(function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
            }
        }
        var promise;
        $scope.getSuggestions = function(viewValue) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function() {
                if (viewValue !== '') {
                    var searchUsers = {
                        serviceid: "mlf_extuser",
                        Name: viewValue,
                        IsHasRight: true,
                        IsSearchHide: true,
                    };
                    searchUsers.methodname = !noRightFilter ? "queryUsersByName" : "searchUserOrDept"; //过滤是否带权限
                    if ($scope.isRequest) {
                        $scope.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, "post").then(function(data) {
                            angular.forEach(data, function(data_, index, array) {
                                data[index].viewValue = viewValue;
                            });
                            return data;
                        });
                    }
                }
            });
            return promise;
        };
        $scope.$watch('searchWord', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                var flag = true;
                angular.forEach($scope.itemsSd, function(data, index, array) {
                    if (data.ID === newValue.ID) {
                        flag = false;
                    }
                });
                if (flag) {
                    $scope.isRequest = true;
                    newValue.OPERTYPE = newValue.TYPE;
                    newValue.DESC = newValue.USERNAME;
                    $scope.itemsSd.push(newValue);
                }
                $scope.searchWord = newValue.USERNAME;
            }
        });
        /**
         * [groupFormat description] GROUPDESC显示样式格式化
         * @param  {[type]} groupDesc [description] GROUPDESC内容
         * @return {[type]}           [description]
         */
        $scope.groupFormat = function(groupDesc) {
            return '('+groupDesc+')';
        }
    }]);
